export const TOAST_CLASSES = {
    SUCCESS: "insights-toast-success",
    ERROR: "insights-toast-error"
};

export const NO_AGENT_ERROR = {
    title: "To create a new agent, please follow these steps:",
    steps: [
        "Click on the Agent tab.",
        "Select the option to create a new agent.",
        "Once the agent is created, it will appear in the dropdown menu.",
        "Select the newly created agent from the dropdown."
    ]
};

export const UPLOAD_SOLUTION_CONTENT = {
    title: "Upload File",
    description: "Please upload the solution file in .zip format.",
    buttonLabel: "Upload",
    dragDropText: "Drag and drop files here",
    or: "or",
    browseBtnLabel: "Browse",
    downloadTemplate: "Download Template",
    uploadRestrictionTxt: "Only one file can be uploaded at a time"
};

export const UPLOAD_AGENT_CONTENT = {
    title: "Upload File",
    description: "Please upload the agent file in .zip format.",
    buttonLabel: "Upload",
    dragDropText: "Drag and drop files here",
    or: "or",
    browseBtnLabel: "Browse",
    downloadTemplate: "Download Template",
    uploadRestrictionTxt: "Only one file can be uploaded at a time"
};

export const PUBLISHED_TXT = "Published";
export const PUBLISHED_LABEL = "Published";

export const UNPUBLISHED_TXT = "Draft";
export const UNPUBLISHED_LABEL = "Draft";